import { render, staticRenderFns } from "./OrdenCard.vue?vue&type=template&id=0edc31cd"
import script from "./OrdenCard.vue?vue&type=script&lang=js"
export * from "./OrdenCard.vue?vue&type=script&lang=js"
import style0 from "./OrdenCard.vue?vue&type=style&index=0&id=0edc31cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports